module.exports = {"location-widget":{"asOf":"As of","search":"Search for a location","recentlySearched":"Recently Searched","favoritesHeader":"Favorites","inputPlaceholder":"Enter ZIP or City & State","maxReached":"Max Reached","maxReachedDefaultViewFirstLine":"Max.","maxReachedDefaultViewSecondLine":"reached!","currentLocation":"Current Location","changeLocation":"Change Location","pickALocation":"Pick a Location","loading":"Finding Location..."}}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/location-widget/src/intl.json
// module id = 1157
// module chunks = 1